import axios from "axios";
import {
  popularGamesURL,
  upcomingGamesURL,
  newGamesURL,
  searchGameURL,
} from "../api";

//action creator
//double arrow fuction needed for thrunk in order to use async await
export const loadGames = () => async (dispatch) => {
  //fetch with axios
  const upcomingData = await axios.get(upcomingGamesURL());
  const popularData = await axios.get(popularGamesURL());
  const newGamesData = await axios.get(newGamesURL());
  dispatch({
    type: "FETCH_GAMES",
    payload: {
      popular: popularData.data.results,
      newGames: newGamesData.data.results,
      upcoming: upcomingData.data.results,
    },
  });
};

export const fetchSearch = (game_name) => async (dispatch) => {
  //fetch
  const searchGamens = await axios.get(searchGameURL(game_name));

  dispatch({
    type: "FETCH_SEARCHED",
    payload: {
      searched: searchGamens.data.results,
    },
  });
};

export const clearSearch = () => async (dispatch) => {
  dispatch({
    type: "CLEAR_SEARCHED",
  });
};
